import React from 'react';

type LoaderProps = {
  label?: string;
  className?: string;
  overlay?: boolean;
  size?: 'sm' | 'md' | 'lg';
};

const Loader: React.FC<LoaderProps> = (props: LoaderProps) => {
  const { label, className = '', overlay = false, size = 'lg' } = props;
  
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
  };

  const spinner = (
    <svg className={`animate-spin ${sizeClasses[size]} text-[#00AD4A]`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  );

  if (overlay) {
    return (
      <div className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/90 backdrop-blur-sm ${className}`} role="status" aria-live="polite" aria-busy="true">
        <div className="flex flex-col items-center gap-4">
          {spinner}
          {label && <span className="text-gray-700 font-medium text-lg">{label}</span>}
        </div>
      </div>
    );
  }

  const classes = ['flex items-center justify-center min-h-screen w-full', className].filter(Boolean).join(' ');
  return (
    <div className={classes} role="status" aria-live="polite" aria-busy="true">
      {spinner}
    </div>
  );
};

export default Loader;
